<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item" *ngFor="let item of breadcrumbs;let i = index">
      <a routerLink="{{ item.url }}" [class.disabled]="i+1 == breadcrumbs.length">{{ item.name }}</a>
    </li>
<!--    <li class="breadcrumb-item"><a href="#">Library</a></li>-->
<!--    <li class="breadcrumb-item active" aria-current="page">Data</li>-->
  </ol>
</nav>
